import React, { useContext } from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { DefaultButton } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useWizardService, WIZARD_EVENTS } from '@bingads-webui-react/wizard';

import { isAudienceAdGroupCreation, isAudienceAdGroupMultiAdCreation, FLOWS, STEP_PATHS } from '../../../step-constants';

const getStyles = () => ({
  footerContainer: {
    display: 'flex',
    columnGap: '10px',
    marginTop: '20px',
  },
});

export const NativeAdFooter = () => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);
  const { state, send } = useWizardService();

  const { flow } = state.context.wizardData;

  const onSaveAndCreateAnotherAd = () => {
    if (flow === FLOWS.AUDIENCE_CAMPAIGNS) {
      send({
        type: WIZARD_EVENTS.SAVE_AND_GOTO,
        flowFactors: { flow: FLOWS.MULTI_AUDIENCE_CAMPAIGNS },
        stepId: STEP_PATHS.MULTI_AD_MANAGER,
        wizardData: {
          flow: FLOWS.MULTI_AUDIENCE_CAMPAIGNS,
        },
      });
    } else if (isAudienceAdGroupCreation(flow)) {
      send({
        type: WIZARD_EVENTS.SAVE_AND_GOTO,
        flowFactors: { flow: FLOWS.AUDIENCE_AD_GROUP_MULTI_AD_CREATION },
        stepId: STEP_PATHS.MULTI_AD_MANAGER,
        wizardData: {
          flow: FLOWS.AUDIENCE_AD_GROUP_MULTI_AD_CREATION,
        },
      });
    } else {
      send({
        type: WIZARD_EVENTS.SAVE_AND_GOTO,
        stepId: STEP_PATHS.MULTI_AD_MANAGER,
      });
    }
  };

  const onCancel = () => {
    send(WIZARD_EVENTS.NAVIGATE_TO, {
      stepId: STEP_PATHS.MULTI_AD_MANAGER,
    });
  };

  return (
    <div className={classNames([classes.footerContainer, 'native-ads-footer'])}>
      <DefaultButton
        text={i18n.getString(_TL_('Save & create another ad'))}
        onClick={onSaveAndCreateAnotherAd}
        className="save-and-create-another-ad-button"
      />
      {
        // only show cancel button in multi ads workflow.
        (flow === FLOWS.MULTI_AUDIENCE_CAMPAIGNS || isAudienceAdGroupMultiAdCreation(flow)) && (
          <DefaultButton
            text={i18n.getString(_TL_('Cancel'))}
            onClick={onCancel}
            className="cancel-create-another-ad-button"
          />
        )
      }
    </div>
  );
};
